import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import { buildGoogleCalendarUrl, downloadIcs } from "./calendarLinks";

// Calendar icon button + the two-item export menu. Owns the anchor state and
// the side effects (file download / new tab) so EventCard stays presentational.
function AddToCalendarMenu({ event }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (clickEvent) => {
    // The button can sit inside the card's <Link>; without these, opening the
    // menu would also navigate the card.
    clickEvent.preventDefault();
    clickEvent.stopPropagation();
    setAnchorEl(clickEvent.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  const handleDownloadIcs = () => {
    downloadIcs(event);
    handleClose();
  };

  const handleGoogleCalendar = () => {
    window.open(buildGoogleCalendarUrl(event), "_blank", "noopener,noreferrer");
    handleClose();
  };

  // The Menu renders in a portal, but React synthetic events still bubble up
  // the component tree to the card's <Link> — swallow them at the Menu root so
  // item/backdrop clicks never trigger card navigation.
  const swallowClick = (clickEvent) => {
    clickEvent.preventDefault();
    clickEvent.stopPropagation();
  };

  return (
    <React.Fragment>
      <IconButton
        size="small"
        type="button"
        aria-label={`Add ${event.title} to calendar`}
        className="calendar-page__icon-button"
        onClick={handleOpen}
      >
        <CalendarMonthRoundedIcon style={{ fontSize: 16 }} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={swallowClick}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        classes={{ paper: "calendar-page__menu-paper" }}
      >
        <MenuItem
          className="calendar-page__menu-item"
          onClick={handleDownloadIcs}
        >
          Apple Calendar / Outlook (.ics)
        </MenuItem>
        <MenuItem
          className="calendar-page__menu-item"
          onClick={handleGoogleCalendar}
        >
          Google Calendar
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
}

export default AddToCalendarMenu;
